const chips = document.querySelectorAll(".grade-chip");
const title = document.querySelector("[data-program-title]");
const meta = document.querySelector("[data-program-meta]");
const description = document.querySelector("[data-program-description]");
const list = document.querySelector("[data-program-list]");
const cta = document.querySelector("[data-program-cta]");
const heroImage = document.querySelector(".hero-photo-frame img");
const bookingLinks = document.querySelectorAll('a[href^="https://parents.fiboart.com/appointments/free-trial"]');
const bookingUrl = "https://parents.fiboart.com/appointments/free-trial";

const programs = {
  "lil-picasso": {
    title: "Lil' Picasso",
    meta: "PreK-1st grade",
    description:
      "Young artists learn through Art History-inspired projects while building confidence with materials, shapes, portraits, animals, and landscapes.",
    bullets: [
      "Best for students at least 4 years old",
      "One project per class",
      "Watercolors, markers, oil pastels, and chalk pastels"
    ],
    cta: "Book Lil' Picasso Trial",
    href: bookingUrl
  },
  core: {
    title: "Core",
    meta: "2nd-4th grade",
    description:
      "Students build drawing, shading, perspective, and color skills through a structured foundation in Art Fundamentals.",
    bullets: [
      "Designed for elementary artists ready for more structure",
      "Projects average one every two classes",
      "Acrylics, watercolors, charcoal, graphite, and more"
    ],
    cta: "Book Core Trial",
    href: bookingUrl
  },
  masters: {
    title: "Masters",
    meta: "5th-8th grade",
    description:
      "Middle-school students deepen technique, reference drawing, perspective, shading, and independent project execution.",
    bullets: [
      "For students ready to level up beyond the basics",
      "Projects average one every three classes",
      "Advanced fundamentals with individualized instruction"
    ],
    cta: "Book Masters Trial",
    href: bookingUrl
  },
  portfolio: {
    title: "Portfolio",
    meta: "9th-12th grade",
    description:
      "Older students combine Art Fundamentals, Art History, and personal style development in a more mature studio environment.",
    bullets: [
      "For high-school artists building style and confidence",
      "Projects average one every four classes",
      "Conceptual ideas, advanced media use, and technical support"
    ],
    cta: "Book Portfolio Trial",
    href: bookingUrl
  }
};

function appendCurrentQuery(url) {
  const currentParams = new URLSearchParams(window.location.search);

  if (!currentParams.toString()) {
    return url;
  }

  const target = new URL(url, window.location.origin);
  currentParams.forEach((value, key) => {
    target.searchParams.set(key, value);
  });

  return target.toString();
}

function updateBookingLinks() {
  bookingLinks.forEach((link) => {
    link.href = appendCurrentQuery(bookingUrl);
  });
}

function renderProgram(programKey) {
  const program = programs[programKey];

  if (!program || !title || !meta || !description || !list || !cta) {
    return;
  }

  chips.forEach((chip) => {
    chip.classList.toggle("is-active", chip.dataset.program === programKey);
  });

  title.textContent = program.title;
  meta.textContent = program.meta;
  description.textContent = program.description;
  cta.textContent = program.cta;
  cta.href = appendCurrentQuery(program.href);

  list.innerHTML = "";
  program.bullets.forEach((bullet) => {
    const item = document.createElement("li");
    item.textContent = bullet;
    list.appendChild(item);
  });
}

chips.forEach((chip) => {
  chip.addEventListener("click", () => renderProgram(chip.dataset.program));
});

updateBookingLinks();

function updateHeroMobileFocus() {
  if (!heroImage) {
    return;
  }

  const viewportWidth = window.innerWidth;

  if (viewportWidth > 450) {
    heroImage.style.removeProperty("--hero-mobile-focus-x");
    return;
  }

  const progress = Math.min(Math.max((450 - viewportWidth) / 90, 0), 1);
  const focusX = 50 + progress * 15;
  heroImage.style.setProperty("--hero-mobile-focus-x", `${focusX.toFixed(1)}%`);
}

updateHeroMobileFocus();
window.addEventListener("resize", updateHeroMobileFocus);

const galleryViewport = document.querySelector("[data-gallery-viewport]");
const galleryPrev = document.querySelector("[data-gallery-prev]");
const galleryNext = document.querySelector("[data-gallery-next]");

function scrollGallery(direction) {
  if (!galleryViewport) {
    return;
  }

  const slide = galleryViewport.querySelector(".gallery-slide");
  const amount = slide ? slide.getBoundingClientRect().width + 14 : galleryViewport.clientWidth;

  galleryViewport.scrollBy({
    left: direction * amount,
    behavior: "smooth"
  });
}

galleryPrev?.addEventListener("click", () => scrollGallery(-1));
galleryNext?.addEventListener("click", () => scrollGallery(1));
